export default "__VITE_ASSET__DKb0gsnb__"